import type { EntryTemplate } from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"
import type {
  RxQueryResult,
  UseRxQueryOptions,
} from "rxdb-hooks"
import { useFind } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useFindEntryTemplates(
  queryObject: MangoQuery<EntryTemplate>,
  options?: Omit<UseRxQueryOptions, "json">,
): RxQueryResult<EntryTemplate> {
  return useFind<EntryTemplate>(
    queryObject,
    CollectionKey.EntryTemplate,
    options,
  )
}
